import patternblue from '../assets/images/t1darksmall.png'
import patternpurple from '../assets/images/t2darksmall.png'

export const legendConfigs = {
  tier1: {
    title: 'Tier1',
    color: '#7B4FFA',
    image: null
  },
  tier1Ocuppied: {
    title: 'Tier1 Taken',
    color: '#7392FF',
    image: patternpurple
  },
  tier2Ocuppied: {
    title: 'Tier2 Taken',
    color: '#62D9FF',
    image: patternblue
  }
}
